/**
 * Checks if a given string is present in an array of strings.
 *
 * @param str - The string to search for.
 * @param arr - The array of strings to search within.
 * @returns `true` if the string is found in the array, otherwise `false`.
 */
export const stringInArray = (str, arr) => {
    return arr.includes(str);
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/string.utils.js
// module id = ./node_modules/@celine/passive-tracking/dist/string.utils.js
// module chunks = 0